import { createReducer, on } from '@ngrx/store';
import { TermsResponse } from '../../../domain/models/terms.model';
import * as LegalActions from '../actions/legal.actions';

export const initialState: TermsResponse = {
    signedTerms: [],
    pendingTerms: [],
};

export const legalTermsReducer = createReducer(
    initialState,
    on(LegalActions.loadLegalTermsSuccess, (state, { terms }) => terms)
);
